exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout-room__resort {\n  margin-bottom: 40px; }\n\n@media (min-width: 768px) {\n  .checkout-room {\n    margin-bottom: 0; } }\n\n.checkout-overview {\n  text-align: center;\n  margin-bottom: .5em; }\n  .checkout-overview__title {\n    font-weight: 400;\n    margin: 0 1rem 1rem; }\n    @media screen and (min-width: 768px) {\n      .checkout-overview__title {\n        margin: 0 1rem 1rem 0; } }\n  .checkout-overview__desc {\n    font-size: .9em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/resort-information/resort-information.component.scss
// module id = ../../../../../src/app/check-out/resort-information/resort-information.component.scss
// module chunks = main